<template>
  <div>
    <a-spin :spinning="loading">
      <a-form ref="form" name="form" :model="modelRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 10 }"
              @finish="onSubmit">

        <a-form-item label="重启服务" name="apps" :rules="[{ required: true, message: '必填项不允许为空' }]">
          <a-checkbox-group v-model:value="modelRef.apps">
            <a-checkbox value="app" name="apps">app</a-checkbox>
            <a-checkbox value="admin" name="apps">admin</a-checkbox>
            <a-checkbox value="pay" name="apps">pay</a-checkbox>
            <a-checkbox value="mq" name="apps">mq</a-checkbox>
            <a-checkbox value="jobs" name="apps">jobs</a-checkbox>
            <a-checkbox value="erp" name="apps">erp</a-checkbox>
          </a-checkbox-group>
        </a-form-item>

        <div style="text-align: center;margin-bottom: 20px">
          <a-button type="primary" html-type="submit">重启</a-button>
        </div>

      </a-form>
    </a-spin>
  </div>
</template>

<script>

  import { restartAppServer } from "@/service/modules/system";

  export default {
    components: {},
    data() {
      return {
        loading: false,
        modelRef: {
          apps: []
        },
      }
    },
    created() {
    },
    computed: {

    },
    methods: {
      async onSubmit() {
        this.loading = true;
        const postData = {
          apps: this.modelRef.apps.join(',')
        };
        try {
          const res = await restartAppServer(postData);
        } catch (e) {

        }
        this.loading = false;
      },
    }
  }
</script>

<style scoped>

</style>
